import { render, staticRenderFns } from "./SuggestTable.vue?vue&type=template&id=5d7f531c&scoped=true"
import script from "./SuggestTable.vue?vue&type=script&lang=ts"
export * from "./SuggestTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7f531c",
  null
  
)

export default component.exports